<template>
  <YdDialog
    :title="title"
    :visible.sync="showVisible"
    append-to-body
    @close="closeEdit"
    width="80%"
    @open="openEdit"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      style="margin-left: 30px; margin-right: 10px"
      size="mini"
      label-position="left"
      label-width="100px"
    >
      <div class="title-box">兑换数据</div>
      <div class="ac_tabs">
        <div class="ac_tabs-contain">
          <el-descriptions :column="4" size="small" border>
            <el-descriptions-item label="兑换码数量">{{ form.totalCount }}</el-descriptions-item>
            <el-descriptions-item label="未兑换">{{ form.suplusCount }}</el-descriptions-item>
            <el-descriptions-item label="已兑换">{{ form.exchangeCount }}</el-descriptions-item>
            <el-descriptions-item label="已作废">{{ form.cancelCount }}</el-descriptions-item>
            <el-descriptions-item label="已使用">{{ form.useCount }}</el-descriptions-item>
            <el-descriptions-item label="未使用">{{ form.notUseCount }}</el-descriptions-item>
            <el-descriptions-item label="兑换比例"
              >{{
                ((form.exchangeCount / form.totalCount) * 100).toFixed(2)
              }}%</el-descriptions-item
            >
            <el-descriptions-item />
            <el-descriptions-item label="创建时间">{{ form.createTime }}</el-descriptions-item>
            <el-descriptions-item label="创建人">{{ form.createUserName }}</el-descriptions-item>
            <el-descriptions-item label="隶属公司">{{ form.merchantName }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div class="title-box margin-top-15">兑换明细</div>

      <el-form ref="query" size="mini" :inline="true">
        <el-form-item label="兑换手机号：">
          <el-input
            v-model="pagination.redemptionMobilePhone"
            placeholder="请输入兑换手机号"
            clearable
          />
        </el-form-item>
        <el-form-item label="兑换状态：">
          <avue-select
            v-model="redemptionStatusList"
            placeholder="请选择状态"
            :dic="[
              { label: '未兑换', value: 1 },
              { label: '已兑换', value: 2 },
              { label: '已作废', value: 3 }
            ]"
          />
          <!-- <YdMerchantSelector v-model="query.merchantId" placeholder="请选择隶属公司" /> -->
        </el-form-item>
        <el-form-item label="使用情况：">
          <avue-select
            v-model="useStatusList"
            placeholder="请选择使用情况"
            :dic="[
              { label: '未使用', value: 1 },
              { label: '已使用', value: 2 }
            ]"
          />
        </el-form-item>
        <el-form-item label="兑换时间：">
          <el-date-picker
            v-model="dateSlot"
            type="datetimerange"
            prop="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            valueFormat="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="exchangeChange"
          />
        </el-form-item>
        <el-form-item label="操作时间：">
          <el-date-picker
            v-model="editSlot"
            type="datetimerange"
            prop="datetimerange"
            format="yyyy-MM-dd HH:mm:ss"
            valueFormat="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="editChange"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchChange" :loading="loading"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-download"
            @click="handleDownload"
            :loading="loading"
            v-has-permi="['coupon_code_edit_dowload']"
            >下载</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-folder-delete"
            @click="handleCancel"
            :loading="loading"
            v-has-permi="['coupon_code_edit_operation']"
            >批量作废</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-folder-checked"
            @click="handleRestore"
            v-has-permi="['coupon_code_edit_operation']"
            :loading="loading"
            >批量恢复</el-button
          >
        </el-form-item>
      </el-form>
      <div style="padding-top: 10px">
        <yd-table
          :loading="loading"
          :data="records"
          border
          size="mini"
          :pagination="pagination"
          @selection-change="selectionChange"
          :row-key="getRowKeys"
          @onChange="onTableChange"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="兑换码" align="center" prop="redemptionCode" />
          <el-table-column label="兑换手机号" align="center" prop="redemptionPhone" />
          <!-- <el-table-column label="兑换手机号" align="center">
			<template slot-scope="scope">
				<div v-if="scope.row.redemptionPhone">
					<yd-link
					  permi="user_center_manage"
					  :value="scope.row.redemptionPhone"
					  :url="phoneUrl(formData, scope.row.redemptionPhone)"
					  :need="true"
					  type="userInfo"
					/>
				</div>
			</template>
		  </el-table-column> -->
          <el-table-column label="兑换时间" align="center" prop="redemptionTime" />
          <el-table-column label="使用情况" align="center" prop="useStatusName" width="80" />
          <el-table-column label="状态" align="center" prop="redemptionStatusName" width="80" />
          <el-table-column label="操作人" align="center" prop="createUserName" width="100" />
          <el-table-column label="操作时间" align="center" prop="updateTime" width="140" />
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.redemptionStatus === 3"
                type="text"
                size="mini"
                @click="restore(scope.row)"
                v-has-permi="['coupon_code_edit_operation']"
                >恢复</el-button
              >
              <el-button
                v-if="scope.row.redemptionStatus !== 3 && scope.row.redemptionStatus !== 2"
                type="text"
                size="mini"
                @click="deletes(scope.row)"
                v-has-permi="['coupon_code_edit_operation']"
                >作废</el-button
              >
            </template>
          </el-table-column>
        </yd-table>
        <!-- <div style="text-align: right">
          <pagination
            v-if="pagination.total > 0"
            :total="pagination.total"
            :page.sync="pagination.current"
            :limit.sync="pagination.size"
            @pagination="getTableData"
          />
        </div> -->
      </div>
    </el-form>
  </YdDialog>
</template>

<script>
  import env from '@/config/env'
  import exportToExcel from '@/views/office/documentManage/hooks/exportToExcel'

  import {
    getDataSummary,
    postDataSummaryPage,
    postCancelOrRestore
  } from '@/api/marketing/coupon-code-redemption'

  export default {
    props: {
      formData: {
        type: Object,
        default: () => {}
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        pagination: {
          current: 1,
          size: 10,
          total: 0
        },
        redemptionStatusList: null,
        useStatusList: null,
        showVisible: false,
        form: {},
        query: {},
        selectList: [],
        dateSlot: [],
        editSlot: []
      }
    },
    computed: {
      title() {
        return this.formData.name + '数据管理'
      }
    },
    mounted() {
      this.pagination.activityId = this.formData.id
      this.showVisible = this.visible
      this.getDataSummaryFun()
    },
    methods: {
      //  phoneUrl(item){
      // return `/customer/user/index/${item.phone}/${item.id}`
      //  },

      exchangeChange(v) {
        if (v) {
          this.pagination.redemptionStartTime = v[0]
          this.pagination.redemptionEndTime = v[1]
        } else {
          this.pagination.redemptionStartTime = null
          this.pagination.redemptionEndTime = null
        }
      },
      editChange(v) {
        if (v) {
          this.pagination.operateStartTime = v[0]
          this.pagination.operateEndTime = v[1]
        } else {
          this.pagination.operateStartTime = null
          this.pagination.operateEndTime = null
        }
      },
      async handleDownload() {
        if (this.selectList.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择要下载的兑换码'
          })
          return
        }
        const url = env.importExcelUrl + env.ferryUrl + '/activity-redemption/download'
        exportToExcel('post', url, this.pagination)
      },

      searchChange() {
        this.pagination.current = 1
        if (this.useStatusList) {
          this.pagination.useStatusList = [this.useStatusList]
        } else {
          this.pagination.useStatusList = []
        }
        if (this.redemptionStatusList) {
          this.pagination.redemptionStatusList = [this.redemptionStatusList]
        } else {
          this.pagination.redemptionStatusList = []
        }
        this.getTableData()
      },
      getRowKeys(row) {
        return row.id
      },
      async getDataSummaryFun() {
        const res = await getDataSummary(this.formData.id)
        if (res.code === 0) {
          this.form = res.data
        }
      },

      async getTableData() {
        const res = await postDataSummaryPage(this.pagination)
        if (res.code === 0) {
          this.records = res.data.records
          this.pagination.total = res.data.total
          this.$forceUpdate()
        }
      },

      // 表格选项
      selectionChange(v) {
        this.selectList = v
      },

      closeEdit() {
        this.$emit('closeEdit')
      },

      onTableChange({ current, pageSize }) {
        this.pagination.current = current
        this.pagination.size = pageSize
        this.getTableData()
      },

      deletes(row) {
        this.$confirm('确认是否作废优惠券，作废后用户不可兑换', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            const arr = [row.id]
            this.postCancelOrRestoreFun(arr, 1)
          })
          .catch(() => {})
      },

      restore(row) {
        this.$confirm('确认是否恢复优惠券，恢复后用户可进行兑换', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            const arr = [row.id]
            this.postCancelOrRestoreFun(arr, 2)
          })
          .catch(() => {})
      },

      handleCancel() {
        if (this.selectList.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择要操作的兑换码'
          })
          return
        }
        const index = this.selectList.findIndex(
          (i) => i.redemptionStatus === 3 || i.redemptionStatus === 2
        )
        if (index > -1) {
          this.$message({
            type: 'info',
            message: '请选择非作废/未兑换优惠券'
          })
          return
        }
        this.$confirm('确认是否批量作废优惠券，作废后用户不可兑换', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            const arr = []
            this.selectList.forEach((item) => {
              arr.push(item.id)
            })
            this.postCancelOrRestoreFun(arr, 1)
          })
          .catch(() => {})
      },
      handleRestore() {
        if (this.selectList.length === 0) {
          this.$message({
            type: 'info',
            message: '请选择要操作的兑换码'
          })
          return
        }
        const index = this.selectList.findIndex(
          (i) => i.redemptionStatus !== 3 && i.redemptionStatus !== 2
        )
        if (index > -1) {
          this.$message({
            type: 'info',
            message: '请选择已作废/未兑换优惠券'
          })
          return
        }
        this.$confirm('确认是否批量恢复优惠券，恢复后用户可进行兑换', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            const arr = []
            this.selectList.forEach((item) => {
              arr.push(item.id)
            })
            this.postCancelOrRestoreFun(arr, 2)
          })
          .catch(() => {})
      },
      // 删除恢复
      async postCancelOrRestoreFun(ids, type) {
        const data = {
          idList: ids,
          operate: type // 1作废 2恢复
        }
        const res = await postCancelOrRestore(data)
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.$nextTick(() => {
            this.searchChange()
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .tipsBox {
    display: inline-block;
    font-size: 13px;
    color: #9f9f9f;
    margin-left: 10px;
  }

  .disabled ::v-deep .el-upload--picture-card {
    display: none;
  }

  .disabled ::v-deep .el-upload__tip {
    margin-top: -10px;
  }
</style>
